import { InputAdornment, IconButton, styled } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ReactComponent as XIcon } from 'images/x.svg';

import { TextInput } from 'components/PKDTextField';

export const StyledInputAdornment = styled(InputAdornment)({
  margin : '0 17px 0 8px',
});

export const StyledTextInput = styled(TextInput)(({ theme }) => ({
  '& > .MuiInputBase-root' : {
    backgroundColor : theme.palette.primary.white,
    '&.Mui-focused' : {
      '& > .MuiOutlinedInput-notchedOutline' : {
        border : `solid 1px ${theme.palette.primary.blue1}`,
      },
    },
    '&:hover' : {
      '& > .MuiOutlinedInput-notchedOutline' : {
        border : `solid 1px ${theme.palette.primary.blue1}`,
      },
    },
  },
}));

export const StyledSearchIcon = styled(SearchIcon)(({ theme }) => ({
  color  : theme.palette.primary.white,
  height : '24px',
  width  : '24px',
}));

export const SearchButton = styled(IconButton)(({ theme }) => ({
  backgroundColor : theme.palette.primary.blue1,
  borderRadius    : '8px',
  width           : '56px',
  height          : '56px',
  transition      : 'none',
  '&:hover'       : {
    backgroundColor : theme.palette.primary.blue1,
  },
  '&.Mui-disabled' : {
    opacity         : 0.5,
    backgroundColor : theme.palette.primary.gray4,
  },
}));

export const StyledXIcon = styled(XIcon)(({ theme }) => ({
  height : '17px',
  width  : '17px',
  cursor : 'pointer',
  path   : {
    fill : theme.palette.primary.gray25,
  },
}));
